import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import NumberInputComponent from './NumberInputComponent';
import replaceValueInEvent from '../../../helper/replaceValueInEvent';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';
import { onKeyDownDenyCharacters, nonNumericNumberInputCharacters } from '../../../helper/form/onKeyDownDenyCharacters';

const formatDate = (day, month, year) => `${day}-${month}-${year}`;

class SplitDateInputComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      day: props.day,
      month: props.month,
      year: props.year,
      value: formatDate(props.day, props.month, props.year),
    };

    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this);

    this.onDayChangeHandler = this.onDayChangeHandler.bind(this);
    this.onMonthChangeHandler = this.onMonthChangeHandler.bind(this);
    this.onYearChangeHandler = this.onYearChangeHandler.bind(this);

    this.dayInput = createRef();
    this.monthInput = createRef();
    this.yearInput = createRef();
  }

  onDayChangeHandler(e) {
    this.onChangeHandler('day', e);
  }

  onMonthChangeHandler(e) {
    this.onChangeHandler('month', e);
  }

  onYearChangeHandler(e) {
    this.onChangeHandler('year', e);
  }

  onChangeHandler(what, e) {
    const newState = this.state;
    newState[what] = e.target.value;

    if (newState.day !== '' && newState.month !== '' && newState.year !== '') {
      newState.value = formatDate(newState.day, newState.month, newState.year);
    } else {
      newState.value = '';
    }

    this.setState(newState);

    this.props.onChangeHandler(replaceValueInEvent(e, newState));
  }

  onKeyDownHandler(e) {
    const { keyCode, target } = e;

    if (String(window.getSelection())) target.value = '';

    const { value } = target;

    /**
     * Keycodes for numbers, also for keypad
     * in order: 0, 1, 2, 3, 4, 5, 6, 7, 8 ,9
     * @type {number[]}
     */
    const whitelistedKeys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    const backspace = 8;

    if (value.length >= 2 && whitelistedKeys.includes(keyCode)) {
      switch (e.target) {
      case this.dayInput.current:
        this.monthInput.current.value = '';
        this.monthInput.current.focus();
        break;
      case this.monthInput.current:
        this.yearInput.current.value = '';
        this.yearInput.current.focus();
        break;
      default:
        break;
      }
    } else if (value.length === 0 && keyCode === backspace) {
      switch (e.target) {
      case this.yearInput.current:
        this.monthInput.current.focus();
        break;
      case this.monthInput.current:
        this.dayInput.current.focus();
        break;
      default:
        break;
      }
    }


    if (onKeyDownDenyCharacters(e, nonNumericNumberInputCharacters)) {
      this.props.onKeyDownHandler(e);
    }
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(e);
  }

  render() {
    const {
      name,
      errors,
      autoFocusDay,
      autoFocusMonth,
      autoFocusYear,
      readOnly
    } = this.props;

    return [
      <div className="group col-md-4 col-xs-4" key="day">
        <NumberInputComponent
          readOnly={readOnly}
          autoFocus={autoFocusDay}
          inputRef={this.dayInput}
          name={`${name}_day`}
          label="Dag"
          type="number"
          value={this.state.day}
          onChangeHandler={this.onDayChangeHandler}
          onBlurHandler={this.onBlurHandler}
          onKeyDownHandler={this.onKeyDownHandler}
          id={`${name}_day`}
          errors={hasErrors(errors)}
        />
      </div>,
      <div className="group col-md-4 col-xs-4" key="month">
        <NumberInputComponent
          readOnly={readOnly}
          autoFocus={autoFocusMonth}
          inputRef={this.monthInput}
          name={`${name}_month`}
          label="Maand"
          type="number"
          value={this.state.month}
          onChangeHandler={this.onMonthChangeHandler}
          onBlurHandler={this.onBlurHandler}
          onKeyDownHandler={this.onKeyDownHandler}
          id={`${name}_month`}
          errors={hasErrors(errors)}
        />
      </div>,
      <div className="group col-md-4 col-xs-4" key="year">
        <NumberInputComponent
          readOnly={readOnly}
          autoFocus={autoFocusYear}
          inputRef={this.yearInput}
          name={`${name}_year`}
          label="Jaar"
          type="number"
          value={this.state.year}
          onChangeHandler={this.onYearChangeHandler}
          onBlurHandler={this.onBlurHandler}
          onKeyDownHandler={this.onKeyDownHandler}
          id={`${name}_year`}
          errors={hasErrors(errors)}
        />
      </div>,
      <ErrorComponent errors={errors} key="errors" />,
    ];
  }
}

SplitDateInputComponent.propTypes = {
  readOnly: PropTypes.bool,
  autoFocusDay: PropTypes.bool,
  autoFocusMonth: PropTypes.bool,
  autoFocusYear: PropTypes.bool,
  name: PropTypes.string.isRequired,
  day: PropTypes.string,
  month: PropTypes.string,
  year: PropTypes.string,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onKeyDownHandler: PropTypes.func,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

SplitDateInputComponent.defaultProps = {
  readOnly: false,
  autoFocusDay: false,
  autoFocusMonth: false,
  autoFocusYear: false,
  day: '',
  month: '',
  year: '',
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  onKeyDownHandler: () => {},
  errors: null,
};

export default SplitDateInputComponent;
